import type { IconSvgObject } from './types';

const ArrowDown01Icon: IconSvgObject = [
  ["path", { d: "M5.99977 9.00005L11.9998 15L17.9998 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default ArrowDown01Icon;
